import { useState, useEffect  } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Confirm from "./Confirm"
import limpiarCampos from "../helpers/datos/limpiarCampos";

import { generarPDF } from "../helpers/pdf/generarPDF";
import generarExcel from "../helpers/reportes/generarExcel";
import crearContribuyente from "../helpers/contribuyente/contribuyente/crear";


/**
 * Componente de la barra de Herramientas
 * @param {Object} param0 
 * @returns Componente React
 */
const Herramientas = ({ setData, data, nuevosTramites, aPagar, vigencia, observaciones,
    setObservaciones, anualidad, setAnualidad, setFolio, setNuevosTramites, setListaEstatus,
    setListaUsuarios, setIdTramite, setIdConceptoPago, primavera1, primavera2,
    valoresReporteGeneral, listaEstatus, listaUsuarios, catalogos
}) => {

    const navigate = useNavigate();
    const { pathname: path } = useLocation();

    const usuarioObj = JSON.parse(localStorage.getItem("usuario"));
    const { name, lastName, surname } = usuarioObj ?? {};
    const [isModalOpen, setModalIsOpen] = useState(false);
    const toggleModal = () => setModalIsOpen(!isModalOpen);

    const salir = async () => {
        limpiarCampos(setData, setObservaciones, setAnualidad, setFolio, setNuevosTramites,
            setListaEstatus, setListaUsuarios, setIdTramite, setIdConceptoPago);
        await fetch("/api/usuario/logout", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include"
        });
        localStorage.removeItem("usuario");
        navigate("/");
    }

    const crear = async () => await crearContribuyente(data, setData);

    var inactivityTime = function () {
        var time;
        window.onload = resetTimer;
        document.onmousemove = resetTimer;
        document.onkeydown = resetTimer;

        function logout() {
            limpiarCampos(setData, setObservaciones, setAnualidad, setFolio, setNuevosTramites, setListaEstatus, setListaUsuarios, setIdTramite, setIdConceptoPago);
            if (usuarioObj.userID && usuarioObj.email) {
                salir();
            }
        }

        function resetTimer() {
            clearTimeout(time);
            time = setTimeout(logout, 1000 * 5 * 60);
        }
    };

    useEffect(() => {
        window.onload = function () {
            inactivityTime();
        }
        window.onbeforeunload = function () {
            limpiarCampos(setData, setObservaciones, setAnualidad, setFolio, setNuevosTramites, setListaEstatus, setListaUsuarios, setIdTramite, setIdConceptoPago);
            if (usuarioObj.userID && usuarioObj.email) {
                salir();
            }
        };

    })

    return (
        <>
            <nav className="contenedor-nav background boxRow noGap">

                <NavLink to="/contacto">
                    <button className={`tablinks boton-tab ${path.startsWith("/contacto") && "active"}`} id="defaultOpen">
                        <span className="material-symbols-outlined">face_4 </span> Contribuyente
                    </button>
                </NavLink>

                <NavLink to="/concesion">
                    <button className={`tablinks boton-tab ${path.startsWith("/concesion") && "active"}`} >
                        <span className="material-symbols-outlined">local_taxi</span> Concesión
                    </button>
                </NavLink>

                <NavLink to="/ordenPago">
                    <button className={`tablinks boton-tab ${path.startsWith("/ordenPago") && "active"}`} >
                        <span className="material-symbols-outlined">request_quote</span> Orden de Pago
                    </button>
                </NavLink>

                <NavLink to="/historial">
                    <button className={`tablinks boton-tab ${path.startsWith("/historial") && "active"}`} >
                        <span className="material-symbols-outlined">insert_chart</span> Historial
                    </button>
                </NavLink>


                <NavLink to="/reportes/estatusglobal">
                    <button className={`tablinks boton-tab ${path.startsWith("/reportes") && "active"}`} >
                        <span className="material-symbols-outlined">print</span> Reportes
                    </button>
                </NavLink>

                <button className="boton-tab espacio"></button>

                <button className="btnIconsDisabled">
                    <span className="" title="¡Este soy yo!">{`${name ?? ""} ${lastName ?? ""} ${surname ?? ""}`}</span>
                </button>

                {/* Generar PDF */}
                <button className={path.startsWith("/ordenPago") || path.startsWith("/reportes") ? "btnIcons" : "btnIconsDisabled"}>
                    <span
                        className="material-symbols-outlined"
                        target="_blank"
                        title="Generar Ordenes de pago"
                        onClick={() => path.startsWith("/ordenPago") ?
                            generarPDF(data, setData, nuevosTramites, vigencia, aPagar, observaciones, anualidad, setNuevosTramites) :
                            path.startsWith("/reportes") && generarExcel(primavera1, primavera2, valoresReporteGeneral,
                                listaEstatus, listaUsuarios, catalogos?.usuarios)}>
                        download
                    </span>
                </button>

                {/* Limpiar campos */}
                <button
                    className="btnIcons"
                    onClick={() => limpiarCampos(setData, setObservaciones, setAnualidad, setFolio, setNuevosTramites,
                        setListaEstatus, setListaUsuarios, setIdTramite, setIdConceptoPago)}>
                    <span className="material-symbols-outlined" title="Limpiar">mop</span>
                </button>

                {/* Editar */}
                <button
                    className={data.contribuyente && data.direcciones ? "btnIcons" : "btnIconsDisabled"}
                    onClick={() => data.contribuyente && toggleModal()}>
                    <span
                        className="material-symbols-outlined"
                        title="Editar contribuyente">
                        update
                    </span>
                </button>

                {/* Guardar */}
                <button
                    className={path.startsWith("/contacto") &&
                        data.contribuyente ? "btnIcons" : "btnIconsDisabled"}
                    onClick={() => path.startsWith("/contacto") && data.contribuyente && crear()}>
                    <span className="material-symbols-outlined"
                        title="Guardar nuevo contribuyente">
                        save
                    </span>
                </button>

                {/* Salir */}
                {usuarioObj && (
                    <button className="btnIcons" onClick={salir} >
                        <span className="material-symbols-outlined" title="Salir">logout</span>
                    </button>
                )}
                <ToastContainer />
            </nav>

            {isModalOpen && <Confirm onRequestClose={toggleModal} data={data} />}
        </>
    );
}

export default Herramientas;